import { ContentRequest, TemplateType } from './tax-guide';

export const apiKeys = {
  taxGuide: (userId: string, template: TemplateType) => [
    'taxguideLayout',
    userId,
    template,
  ],
  taxGuideContent: (contentReqiestObj: ContentRequest) => {
    const taxAdv = !contentReqiestObj.taxAdvantage
      ? true
      : contentReqiestObj.taxAdvantage.displayToggle;

    return [
      'taxguideContent',
      contentReqiestObj.countryId +
        contentReqiestObj.planId +
        contentReqiestObj.stateId +
        contentReqiestObj.language +
        taxAdv +
        JSON.stringify(contentReqiestObj.taxCalculationPopupList),
    ];
  },
};
